import { useEffect, useState } from "react";
import { fetchFeatureFlags, DEFAULT_FLAGS } from "../services/researchService";

/**
 * useResearchFlags — Loads research feature flags from Firestore on mount.
 *
 * Returns { flags, loading }.
 *
 * While loading, flags === DEFAULT_FLAGS (all primary features off) so
 * the nav/tabs default to hidden. Once the flags doc loads, we update.
 *
 * Admin toggles flags by editing the researchConfig/featureFlags doc in
 * the Firebase Console. Currently a one-shot read on mount — if you
 * need realtime, swap getDoc for onSnapshot in researchService.
 */
export default function useResearchFlags() {
  const [flags, setFlags] = useState(DEFAULT_FLAGS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    fetchFeatureFlags().then((next) => {
      if (cancelled) return;
      setFlags(next);
      setLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return { flags, loading };
}
